import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'sonner'
import './index.css'
import App from './App.tsx'
import { queryClient } from './lib/queryClient'
import { TooltipProvider } from './components/ui/Tooltip'
import { initSentry, Sentry } from './lib/sentry'

// App boot — Sentry init React tree mount edilmeden önce.
initSentry()

// Twitter widgets.js'i app boot'ta async preload — kullanıcı önizlemeye bastığında
// script çoktan yüklenmiş olur, gecikmesiz iframe render.
function preloadTwitterWidgets() {
  if (document.querySelector('script[data-twitter-widgets]')) return
  const s = document.createElement('script')
  s.src = 'https://platform.twitter.com/widgets.js'
  s.async = true
  s.charset = 'utf-8'
  s.dataset.twitterWidgets = 'true'
  document.head.appendChild(s)
}
preloadTwitterWidgets()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={({ error, resetError }) => <ErrorFallback error={error as Error} retry={resetError} />}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider delayDuration={200} skipDelayDuration={100}>
          <App />
          <Toaster theme="dark" position="top-right" richColors closeButton />
        </TooltipProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)

function ErrorFallback({ error, retry }: { error: Error; retry: () => void }) {
  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-[var(--color-bg)]">
      <div className="max-w-md text-center space-y-3">
        <h1 className="text-xl font-semibold text-[var(--color-text)]">Bir şey ters gitti</h1>
        <p className="text-sm text-[var(--color-text-muted)]">
          Sayfa yüklenirken hata oluştu. Hata otomatik raporlandı. Lütfen birkaç saniye sonra tekrar dene.
        </p>
        <pre className="text-xs text-left p-3 rounded bg-[var(--color-elevated)] border border-[var(--color-border)] text-[var(--color-text-muted)] overflow-auto max-h-40">
          {error.message}
        </pre>
        <div className="flex gap-2 justify-center pt-2">
          <button onClick={retry} className="px-3 py-1.5 rounded bg-[var(--color-accent)] hover:bg-[var(--color-accent-hover)] text-white text-sm">
            Tekrar dene
          </button>
          <button onClick={() => window.location.reload()} className="px-3 py-1.5 rounded border border-[var(--color-border)] hover:bg-[var(--color-elevated)] text-sm">
            Sayfayı yenile
          </button>
        </div>
      </div>
    </div>
  )
}
